module.exports = __webpack_public_path__ + "res/ic_menu_play_t.5d74bd2be170f19a33f976bec468a595.png";